<script>
    /* ВИТРИНА: поиск, сортировка и карточки лотов.
       На карточке сразу видно главное — фото, текущая цена, сколько осталось
       до конца торгов и своё положение («мой лот» / «вы лидируете» /
       «ставку перебили»), чтобы не открывать каждый лот ради одной цифры. */
    import { format } from 'api/formatter'
    import { onInputFocus, onInputBlur } from '../../data'
    import Icon from './icon.svelte'
    import { CATS, catName, catIcon, lotPhoto, leftInfo, myState, betWord, SORTS, sortLots, matchSearch } from './data'

    export let list = [];
    export let tick = 0;
    export let loaded = false;
    export let section = 'all';
    export let uuid = 0;
    export let name = '';
    export let onOpen = () => {};
    export let onCreate = () => {};

    let query = '';
    let sort = 'time';

    /* фото есть только у транспорта, и даже там файл может не найтись —
       битую картинку прячем и показываем значок категории */
    let broken = {};
    const onPhotoFail = (id) => broken[id] = true;

    $: rows = sortLots (list.filter ((item) => matchSearch (item, query)), sort);
    $: empty = section === 'mine' ? { t: 'У вас нет выставленных лотов', s: 'Продайте дом, бизнес или машину — лот увидят все игроки' }
             : section === 'bids' ? { t: 'Вы пока ни за что не торгуетесь', s: 'Откройте любой лот и предложите свою цену' }
             : query ? { t: 'Ничего не нашлось', s: 'Попробуйте другое слово или номер лота' }
             : { t: 'В этом разделе пока пусто', s: 'Загляните в другие категории или выставьте свой лот' };
</script>

<div class="mkpage">
    <div class="mktools">
        <div class="mksearch">
            <Icon name="search"/>
            <!-- фокус в поле обязателен: пока он есть, игра не ловит клавиши -->
            <input type="text" bind:value={query} placeholder="Поиск по названию, продавцу или №"
                   on:focus={onInputFocus} on:blur={onInputBlur}>
        </div>
        <div class="mkseg">
            {#each SORTS as item}
                <div class:on={sort === item.id} on:keypress={() => {}} on:click={() => sort = item.id}>{item.name}</div>
            {/each}
        </div>
        <p class="mkcount">{rows.length} {rows.length === 1 ? 'лот' : 'лотов'}</p>
    </div>

    <div class="mkgrid">
        {#each rows as item (item.id)}
            <div class="mklot" on:keypress={() => {}} on:click={() => onOpen (item.id)}>
                <div class="mklot__photo">
                    {#if lotPhoto (item) && !broken[item.id]}
                        <img src={lotPhoto (item)} alt="" on:error={() => onPhotoFail (item.id)}>
                    {:else}
                        <div class="mkblank">
                            <Icon name={catIcon (item.type)}/>
                            <p>{catName (item.type)}</p>
                        </div>
                    {/if}

                    {#if myState (item, uuid, name) === 'own'}
                        <div class="mkchip own">Мой лот</div>
                    {:else if myState (item, uuid, name) === 'lead'}
                        <div class="mkchip lead">Вы лидируете</div>
                    {:else if myState (item, uuid, name) === 'outbid'}
                        <div class="mkchip outbid">Ставку перебили</div>
                    {:else}
                        <div class="mkchip">{catName (item.type)}</div>
                    {/if}
                    <div class="mkchip num">№{item.id}</div>
                </div>

                <div class="mklot__body">
                    <p class="mklot__title">{item.title || catName (item.type)}</p>
                    <p class="mklot__text">{item.text || 'Продавец не оставил описания'}</p>

                    <div class="mklot__price">
                        <p>Текущая ставка</p>
                        <b>{format ("money", item.lastPrice || 0)}$</b>
                    </div>

                    <div class="mklot__foot">
                        <div class="left">
                            <Icon name="hammer"/>
                            {item.betCount || 0} {betWord (item.betCount)}
                        </div>
                        <div class="left" class:soon={tick >= 0 && leftInfo (item.time).soon}>
                            <Icon name="clock"/>
                            {leftInfo (item.time).text}
                        </div>
                    </div>
                </div>
            </div>
        {:else}
            <div class="mkempty">
                <Icon name="tag"/>
                <p>{loaded ? empty.t : 'Загружаем витрину…'}</p>
                <span>{loaded ? empty.s : 'Секунду, забираем лоты с сервера'}</span>
            </div>
        {/each}
    </div>
</div>
